import productResources from './product';
import subjectResources from './subject';
import publicResources from './public';

export default {
  product: productResources,
  subject: subjectResources,
  public: publicResources,
};
